module.exports = __webpack_public_path__ + "media/St 4-computer-question.57b002e3.wav";